import { authStorageKey, migrateSellerSession } from "../../../Component/axios_Interceptor/authSession";
import React, { useRef, useState } from "react";
import { useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";

import api2 from "../../../Component/axios_Interceptor/api2";
import { setAuthenticatedAccessToken } from "../../../Component/axios_Interceptor/api";

import url from "../../../Component/server";

import { fontStyles } from "../../../Component/style/admin_font";
import { Icon } from "../../../Component/style/common_style";
import SellerAccountRecovery from "./SellerAccountRecovery";
import { GTM_EVENTS, pushGtmEvent } from "../../../Component/analytics/gtm";


const AdminLogin = () => {

  const Navigate = useNavigate();
  const ismobile = /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const mounted = useRef(true);
  const loginLock = useRef(false);


  useEffect(() => {

    migrateSellerSession();
    if (localStorage.getItem("seller_authority") || sessionStorage.getItem("seller_authority")) {

      if (ismobile) {

        Navigate("/admin/livelist");

      } else {

        Navigate("/admin/dashboard");

      }

    }

  }, [Navigate, ismobile]);

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);


  const [id, setID] = useState("");

  const [pw, setPW] = useState("");

  const [autoLogin, setAutoLogin] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [recoveryMode, setRecoveryMode] = useState<"find_id" | "reset_pw" | null>(null);
  const setting_id = (e: React.ChangeEvent<HTMLInputElement>) =>

    setID(e.target.value.replace(" ", ""));

  const setting_pw = (e: React.ChangeEvent<HTMLInputElement>) =>

    setPW(e.target.value);



  const adminLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (loginLock.current) return;
    if (id.trim() === "" || pw === "") {
      setLoginError("아이디와 비밀번호를 입력해 주세요.");
      return;
    }
    loginLock.current = true;
    setSubmitting(true);
    setLoginError("");
    try {
      const res = await api2.post(url.Communication_url.seller_login, {
        userid: id.trim(),
        userpw: pw,
      });
      if (!mounted.current) return;
      const userinfo = res.data;
      if (userinfo.accessToken) {
        const profile = await api2.get(url.Communication_url.user_info, {
          headers: { Authorization: `Bearer ${userinfo.accessToken}` },
        });
        if (!mounted.current) return;
        if (!["master", "linkcam", "cs"].includes(profile.data.user_level)) {
          setLoginError("셀러 계정으로 로그인해 주세요.");
          return;
        }
        pushGtmEvent(GTM_EVENTS.login, profile.data.store_seq || profile.data.userid, profile.data.userid);
        const token_refresh = userinfo.refreshToken;
        if (autoLogin) {

          localStorage.setItem(authStorageKey("key", "seller"), token_refresh);

          localStorage.setItem(authStorageKey("authority", "seller"), "ok");

          sessionStorage.removeItem(authStorageKey("key", "seller"));

          sessionStorage.removeItem(authStorageKey("authority", "seller"));

        } else {

          sessionStorage.setItem(authStorageKey("key", "seller"), token_refresh);

          sessionStorage.setItem(authStorageKey("authority", "seller"), "ok");

          localStorage.removeItem(authStorageKey("key", "seller"));

          localStorage.removeItem(authStorageKey("authority", "seller"));

        }

        setAuthenticatedAccessToken(userinfo.accessToken, "seller");
        if (profile.data.user_level === "linkcam") {
          Navigate("/admin/payment-cancel");
        } else if (profile.data.user_level === "cs") {
          Navigate("/admin/customer-board");
        } else if (ismobile) {
          Navigate("/admin/livelist");

        } else {
          Navigate("/admin/dashboard");
        }
      } else {
        setLoginError("로그인 정보를 확인하지 못했습니다. 다시 시도해 주세요.");
      }
    } catch (error) {
      if (!mounted.current) return;
      const response = (error as { response?: { status?: number; data?: { message?: unknown } } }).response;
      const message = response?.data?.message;
      const serverMessage = typeof message === "string" ? message : Array.isArray(message) && message.every(value => typeof value === "string") ? message.join(" ") : "";
      if (response?.status === 404 && serverMessage === "정보없음") setLoginError("존재하지 않는 아이디입니다.");
      else if (response?.status === 400 && serverMessage === "비밀번호 불일치") setLoginError("비밀번호가 틀렸습니다.");
      else if (response?.status === 403) setLoginError(serverMessage || "셀러 계정의 이용 상태와 입점 승인 여부를 확인해 주세요.");
      else if (response?.status === 401) setLoginError("아이디 또는 비밀번호를 확인해 주세요.");
      else if (!response?.status) setLoginError("서버에 연결하지 못했습니다. 네트워크 상태를 확인하고 다시 시도해 주세요.");
      else setLoginError(response.status < 500 && serverMessage ? serverMessage : "로그인을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.");
    } finally {
      loginLock.current = false;
      if (mounted.current) setSubmitting(false);
    }
  };


  return (

    <Container>

      <Box>

        <div className="logo">

          <Icon
            style={{ height: 58 }}
            src={require("../../../Image/Logo_Text.png")}
            alt="팬버드"
          />
        </div>
        <h1>셀러 관리자 페이지</h1>
        <p className="description">팬버드 셀러 계정으로 로그인해 주세요.</p>

        <form onSubmit={adminLogin}>
        <label htmlFor="seller-login-id">아이디</label>
        <InputBox
          id="seller-login-id"
          value={id}
          onChange={setting_id}
          placeholder="아이디를 입력해주세요."
          autoComplete="username"
          disabled={submitting}
          required
        />

        <label htmlFor="seller-login-password">비밀번호</label>
        <InputBox
          id="seller-login-password"
          value={pw}
          type={"password"}
          onChange={setting_pw}
          placeholder="비밀번호를 입력해주세요."
          autoComplete="current-password"
          disabled={submitting}
          required
        />

        <CheckboxContainer>
          <input
            id="seller-auto-login"
            type="checkbox"
            checked={autoLogin}
            onChange={event => setAutoLogin(event.target.checked)}
            disabled={submitting}
          />
          <label htmlFor="seller-auto-login">자동 로그인</label>
        </CheckboxContainer>

        {loginError && <p className="login-error" role="alert">{loginError}</p>}
        <Btn type="submit" disabled={submitting}>{submitting ? "로그인 중…" : "로그인"}</Btn>
        </form>
        <RecoveryLinks aria-label="계정 정보 찾기">
          <button type="button" onClick={() => setRecoveryMode("find_id")} disabled={submitting}>아이디 찾기</button>
          <span aria-hidden="true" />
          <button type="button" onClick={() => setRecoveryMode("reset_pw")} disabled={submitting}>비밀번호 재설정</button>
        </RecoveryLinks>
        <SignupLink to="/admin/adminsignup" aria-disabled={submitting} onClick={event => { if (submitting) event.preventDefault(); }}>셀러 회원가입</SignupLink>
      </Box>
      {recoveryMode && <SellerAccountRecovery initialMode={recoveryMode} onClose={() => setRecoveryMode(null)} />}
    </Container>

  );

};



export default AdminLogin;



const Container = styled.div`
  display: flex;

  align-items: flex-start;

  justify-content: center;

  box-sizing: border-box;

  padding: 2rem 1.5rem;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background: radial-gradient(circle at 50% 10%, var(--user-surface) 0, var(--user-surface-muted) 42%, var(--user-accent-soft) 100%);
  color: var(--user-text);
  overflow-y: auto;
`;

const Box = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 36rem;
  padding: 3.5rem 4rem 3.25rem;
  margin: auto;

  background-color: var(--user-surface);
  border: 1px solid var(--user-border);
  border-radius: 20px;
  box-shadow: 0 24px 70px rgba(46, 25, 82, 0.12);
  h1 {
    margin: 2.25rem 0 0.75rem;
    font-size: 32px;
    font-weight: 700;
    color: var(--user-text);
  }
  .description {
    margin: 0;
    color: var(--user-text-muted);
    font-size: 16px;
    line-height: 1.6;
  }
  .login-error {
    padding: 11px 12px;
    background: var(--user-error-soft);
    border-radius: 7px;
    color: var(--user-error);
    font-size: 14px;
    line-height: 1.65;
  }
  label {

    display: block;

    margin-top: 1.75rem;
    margin-bottom: 9px;
    font-size: 15px;
    ${fontStyles.medium}

  }

  div.logo {

    position: relative;

    height: 58px;
  }

  img {

    position: absolute;

    left: -2%;
  }
  @media (max-width: 600px) {
    padding: 2.25rem 1.5rem 2rem;
    border-radius: 16px;
    h1 { margin-top: 1.75rem; font-size: 26px; }
    .description { font-size: 14px; }
  }
`;
const InputBox = styled.input`
  background: var(--user-surface);
  color: var(--user-text);
  &::placeholder { color: var(--user-text-muted); }
  box-sizing: border-box;

  width: 100%;

  min-height: 56px;
  padding: 0.95rem 1rem;
  font-size: 16px;

  border-radius: 12px;
  border: 1px solid var(--user-border);
  outline: 0;

  &:hover,

  &:focus {

    border: 1px solid var(--user-accent);
    box-shadow: 0 0 0 3px rgba(96, 65, 170, 0.12);
  }

`;

const Btn = styled.button`
  width: 100%;
  border: 0;
  min-height: 56px;
  padding: 0.95rem;
  margin-top: 1.5rem;
  ${fontStyles.medium}

  text-align: center;

  color: white;

  border-radius: 12px;
  font-size: 17px;
  background: linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep));
  cursor: pointer;
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  &:focus-visible {
    outline: 3px solid #bda9ff;
    outline-offset: 3px;
  }
`;

const SignupLink = styled(Link)`
  box-sizing: border-box;
  display: block;
  min-height: 56px;
  padding: 0.95rem;
  margin-top: 0.875rem;
  border: 1px solid var(--user-border);
  border-radius: 12px;
  font-size: 16px;
  text-align: center;
  text-decoration: none;
  color: var(--user-accent);
  ${fontStyles.medium}
  &[aria-disabled="true"] { opacity: 0.55; cursor: not-allowed; }
  &:focus-visible { outline: 3px solid #bda9ff; outline-offset: 3px; }
`;

const RecoveryLinks = styled.nav`
  display: flex; align-items: center; justify-content: center; gap: 12px; margin-top: 18px;
  button { min-height: 44px; padding: 8px 4px; border: 0; background: transparent; color: var(--user-text-muted); font-size: 14px; cursor: pointer; }
  button:disabled { opacity: 0.55; cursor: not-allowed; }
  span { width: 1px; height: 13px; background: var(--user-border); }
`;


const CheckboxContainer = styled.div`

  display: flex;

  align-items: center;

  margin-top: 1rem;

  margin-bottom: 0.5rem;

  cursor: pointer;


  input {
    margin: 0;

    margin-right: 8px;

    width: 20px;
    height: 20px;
    accent-color: var(--admin-accent);
    cursor: pointer;

  }


  label {

    margin: 0;

    font-size: 14px;

    color: var(--user-text-muted);
    user-select: none;

    cursor: pointer;

    ${fontStyles.medium}

  }

`;

